import httpClient from "../../api/httpClient";
import { AI_ACTIONS } from "../../utils/AiService/constant";
import { callAiRequestApi } from "../../utils/AiService/helper";
import { createWrappedAsyncThunk } from "../createWrappedAsyncThunk";

export const getChatsByTenant = createWrappedAsyncThunk(
  "chats/getChatsByTenant",
  async ({ tenant_id }) => {
    const { data } = await httpClient.get(`conversation`, {
      params: {
        tenant_id,
        limit: 50,
        offset: 0,
      },
    });
    return { tenant_id, data };
  },
);

export const updateFileKey = createWrappedAsyncThunk(
  "chats/updateFileKey",
  async ({ attachment_id }) => {
    return await httpClient.post(`update-file-key`, {
      attachment_id,
    });
  },
);

export const getChatsById = createWrappedAsyncThunk(
  "chats/getChatsById",
  async ({ tenant_id, id }) => {
    const { data } = await httpClient.get(`conversation`, {
      params: {
        tenant_id,
        conversation_user_id: id,
      },
    });
    return { tenant_id, data };
  },
);

export const fetchMessagesByConversationId = createWrappedAsyncThunk(
  "chats/fetchMessagesByConversationId",
  async ({ conversation_id, limit, offset }) => {
    const { data } = await httpClient.get(`messages`, {
      params: {
        conversation_id,
        limit,
        offset,
      },
    });
    return { data };
  },
);

export const fetchNotesByConversationId = createWrappedAsyncThunk(
  "chats/fetchNotesByConversationId",
  async ({ conversation_id }) => {
    const { data } = await httpClient.get(`conversation-notes`, {
      params: {
        conversation_id,
      },
    });
    return { data };
  },
);

export const fetchDocsByConversationId = createWrappedAsyncThunk(
  "chats/fetchDocsByConversationId",
  async ({ conversation_id, page }) => {
    const { data } = await httpClient.get(`conversation/attachments`, {
      params: {
        conversation_id,
        page,
        limit: 20,
      },
    });
    return { data };
  },
);

export const addEditNote = createWrappedAsyncThunk(
  "chats/addEditNote",
  async (payload) => {
    return payload?.conversation_note_id
      ? await httpClient.put(`conversation-note`, payload)
      : await httpClient.post(`conversation-note`, payload);
  },
);

export const fetchRemindersByConversationId = createWrappedAsyncThunk(
  "chats/fetchRemindersByConversationId",
  async ({ conversation_id }) => {
    const { data } = await httpClient.get(`reminders`, {
      params: {
        conversation_id,
      },
    });
    return { data: data };
  },
);

export const addReminder = createWrappedAsyncThunk(
  "chats/addReminder",
  async (payload) => {
    return await httpClient.post(`reminder`, payload);
  },
);

export const fetchChecklistByConversationId = createWrappedAsyncThunk(
  "chats/fetchChecklistByConversationId",
  async ({ conversation_id }) => {
    const { data } = await httpClient.get(`checklists`, {
      params: {
        conversation_id,
      },
    });
    return { data };
  },
);

export const addUpdateCheckpoint = createWrappedAsyncThunk(
  "chats/addUpdateCheckpoint",
  async (payload) => {
    return await httpClient.post(`checklist`, payload);
  },
);

export const updateConversation = createWrappedAsyncThunk(
  "chats/updateConversation",
  async ({ payload }) => {
    return await httpClient.put(`conversation`, payload);
  },
);

export const createConversation = createWrappedAsyncThunk(
  "chats/createConversation",
  async (payload) => {
    const { data } = await httpClient.post(`conversations`, payload);

    return { tenant_id: payload?.tenant_id, data };
  },
);

export const fetchCasesByConversationId = createWrappedAsyncThunk(
  "chats/fetchCasesByConversationId",
  async ({ conversation_id }) => {
    const { data } = await httpClient.get(`case-form`, {
      params: {
        conversation_id,
        is_all: true,
      },
    });
    return { data };
  },
);

export const addEditCase = createWrappedAsyncThunk(
  "chats/addEditCase",
  async (payload) => {
    return await httpClient.post(`save-case`, payload);
  },
);

export const fetchSummariesByConversationId = createWrappedAsyncThunk(
  "chats/fetchSummariesByConversationId",
  async ({ conversation_id }) => {
    const { data } = await httpClient.get(`summaries`, {
      params: {
        conversation_id,
        is_all: true,
      },
    });
    return { data };
  },
);

export const addEditSummary = createWrappedAsyncThunk(
  "chats/addEditSummary",
  async (payload) => {
    const data = await callAiRequestApi({
      action: AI_ACTIONS.SUMMARIZE_CONVERSATION,
      payload,
    });
    return data;
  },
);
